import React, { createContext, useCallback, useContext, useState } from "react";

interface LayoutContextType {
    clientLogo?: string;
    clientName?: string;
    setLayoutData: (data: { clientLogo?: string; clientName?: string }) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [layoutData, setLayoutDataState] = useState<{ clientLogo?: string; clientName?: string }>({});

    // Stable identity: pages list it in effect dependencies, and a new function on
    // every render made /client/<slug> re-verify the client in a loop.
    const setLayoutData = useCallback((data: { clientLogo?: string; clientName?: string }) => {
        setLayoutDataState((prev) => ({ ...prev, ...data }));
    }, []);

    return (
        <LayoutContext.Provider value={{ ...layoutData, setLayoutData }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => {
    const context = useContext(LayoutContext);
    if (!context) throw new Error("useLayout must be used within LayoutProvider");
    return context;
};

export default LayoutProvider;